import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import lodash from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import DamHelper from '../../../../@types/model/dam/dam';
import { useGetDamConstructionTypes } from '../../../../hooks/query/dam/masterData/damConstructionTypeQueries';
import CheckTreeItem from '../../../customComponents/tree/CheckTreeItem';
import { IOptionType, OptionType } from '../../../../@types/model/optionType';
import Screen from '../../../customComponentV2/screen/Screen';
import MuiAutocompleteSelect from '../../../customComponentV2/input/MuiAutoCompleteSelect';
import CustomTable from '../../../customComponentV2/DataGrid/CustomTable';
import { IDamConstructionType } from '../../../../@types/modelV2/masterData/dam/damConstructionType/damConstructionType';
import LabelledCheckbox from '../../../customComponentV2/input/LabelledCheckbox';
import ArrayHelper from '../../../../services/helper/arrayHelper';
import { ISqlEmployee } from '../../../../@types/modelV2/rights/user/sqlEmployee';

interface IUserDamConstructionTypesDialogProps {
    user : ISqlEmployee | null;
    value : Array<number>;
    onChange : (types : Array<number>) => void;
}


const UserDamConstructionTypesDialog = (props : IUserDamConstructionTypesDialogProps) => {

    const [selectedDamConstructionTypes, setSelectedDamConstructionTypes] = useState<Array<IOptionType>>([]);

    const { isLoading: isLoadingDamConstructionTypes, data: damConstructionTypes } = useGetDamConstructionTypes();

    useEffect(() => {
        if (!props.user || !damConstructionTypes) return;

        const damConstructionTypeOptionTypes : Array<IOptionType> = damConstructionTypes
                .filter(x => x.isActive && !!props.user!.damConstructionTypeIds?.includes(x.id))
                .map(OptionType.fromDataModel) ?? [];

        setSelectedDamConstructionTypes(damConstructionTypeOptionTypes);
    }, [props.user, damConstructionTypes]);

    const onDamConstructionTypeCheck = (checked : boolean, row : IDamConstructionType) : void => {
        const index = selectedDamConstructionTypes.findIndex(x => x.value === row.id);
        let updatedList : Array<IOptionType> = [];

        if (checked) {
            if (index !== -1) return;

            const divisionsOptionType = OptionType.fromDataModel(row);
            
            updatedList = ArrayHelper.addElement(selectedDamConstructionTypes, divisionsOptionType);
        } else {
            if (index === -1) return;
            
            updatedList = ArrayHelper.removeElement(selectedDamConstructionTypes, index);
        }

        props.onChange(updatedList.map(x => Number(x.value)));

        setSelectedDamConstructionTypes(updatedList);
    };

    const renderDamConstructionTypeCheckbox = (division : IDamConstructionType) : React.ReactElement => {
        return (
            <div key={division.id} className={'aic pl10'}>
                <LabelledCheckbox
                    className={'h30 w30'}
                    name={`division_${division.guid}_check_box`}
                    onChange={(e, checked) : void => onDamConstructionTypeCheck(checked, division)}
                    value={!!selectedDamConstructionTypes.some(x => x.value === division.id)}/>
            </div>
        );
    };

    return (
        <Screen
            useAnimatedLoader
            isLoading={isLoadingDamConstructionTypes}
            backgroundColor='bcw'>
            <CustomTable<IDamConstructionType>
                enableSorting
                enableFiltering
                fitWidthToPage
                columns={[
                    { title: '', field: 'guid',
                        containerComponent: renderDamConstructionTypeCheckbox,
                    },
                    { title: 'Name', field: 'name', enableFiltering: true, enableSorting: true },
                ]}
                rows={damConstructionTypes ?? []}
                initialSortOrder={[{ columnName: 'createdOn_Created On', direction: 'desc' }]}
            />
        </Screen>
    );
}

export default UserDamConstructionTypesDialog;